import { useEffect, useState } from "react";
import { AssortGroup } from "../../../../models/AssortGroup";
import useDesktopSize from "../../../../../utils/hooks/useDesktopSize";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import { ASSORT_GROUP_BY_FACILITY_URL } from "../../../../api/apiRoutes";
import useFacility from "../../../../../utils/hooks/useFacility";

export default function useBarMenuManager(setActiveGroup: (value: AssortGroup) => void) {
  const { get } = useApiRequest();
  const facilityIds = useFacility();
  const isDesktop = useDesktopSize();
  const [currentPage, setCurrentPage] = useState(0);
  const [menuList, setMenuList] = useState<AssortGroup[][]>([[]]);
  const maxPage = menuList.length - 1;

  const paginateAssortGroup = (assortGroup: AssortGroup[], itemsOnPage: number) => {
    const paginatedAssortGroup = [];
    for (let i = 0; i < assortGroup.length; i = i + itemsOnPage) {
      paginatedAssortGroup.push(assortGroup.slice(i, i + itemsOnPage));
    }
    return paginatedAssortGroup.length > 0 ? paginatedAssortGroup : [[]];
  };

  const getAssortGroup = async () => {
    const { result, isError } = await get(ASSORT_GROUP_BY_FACILITY_URL(facilityIds));
    if (!isError) {
      const itemsOnPage = isDesktop ? 5 : 3;
      setMenuList(paginateAssortGroup(result, itemsOnPage));
      if (result.length > 0) {
        setActiveGroup(result[0]);
      }
    }
  };

  useEffect(() => {
    getAssortGroup();
  }, [currentPage, isDesktop]);

  return {
    menuList,
    maxPage,
    currentPage,
    setCurrentPage,
  };
}
